import React, { PropsWithChildren } from "react";

const CompetitorMarker = (props: PropsWithChildren<any>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="49"
      height="65"
      fill="none"
      viewBox="0 0 49 65"
      style={{transform:"translate(-50%,-100%)"}}
      {...props}>
      <path
        fill="#b34c6e"
        d="M21.731 63.668c1.137 1.776 3.79 1.776 4.927 0 18.447-26.634 21.858-29.424 21.858-39.317C48.516 10.907 37.65 0 24.258 0 10.739 0 0 10.907 0 24.351c0 9.893 3.285 12.683 21.731 39.317z"></path>
    </svg>
  );
};

export default React.memo(CompetitorMarker);
